'use client';

import React, { useEffect } from 'react';
import AppHeader from '@/components/AppHeader';
import CourseListing from '@/components/course-listing/CourseListing';
import { useAuth } from '@/contexts/AuthContext';
import { useAnalytics } from '@/contexts/AnalyticsContext';
import { LMS_EVENTS } from '@/lib/analytics';

export default function CoursesPage() {
  const { user } = useAuth();
  const { track } = useAnalytics();

  useEffect(() => {
    track(LMS_EVENTS.COURSES_PAGE_VIEWED);
  }, []);

  return (
    <div className="min-h-screen bg-slate-50">
      <AppHeader />
      <main className="max-w-5xl mx-auto px-6 py-12 space-y-8">
        <header className="space-y-2">
          {user ? (
            <>
              <h1 className="text-3xl font-bold text-slate-800">My Courses</h1>
              <p className="text-slate-500">Continue your learning journey</p>
            </>
          ) : (
            <>
              <h1 className="text-3xl font-bold text-slate-800">Courses</h1>
              <p className="text-slate-500">Explore the Spreadd Learning Platform</p>
            </>
          )}
        </header>
        <CourseListing />
      </main>
    </div>
  );
}
